import axios from '../axios';
const END_POINT = '/medical-records/legacy-file/attach';
const createMedicalRecordLegacy = (userId, payload) =>  axios.patch(`${END_POINT}/${userId}`, payload, {headers: {'Content-Type': 'multipart/form-data'}});
const deleteMedicalRecordLegacy = (userId) => axios.delete(`${END_POINT}/${userId}`);

export {
    createMedicalRecordLegacy,
    deleteMedicalRecordLegacy,
}